import React from "react";
import axios from "axios";
import "./MenuSefaz.css";
import ModalPreferences from "../ModalPreferences";
import formatCpfCnpj from "../../helper/formatCpfCnpj";
import { connect } from "react-redux";
import { signOut } from "../../helper/actions/fetchActions/fetchAuth";
import { getEnviromentVariable } from "../../config/enviroment";
import Constants from "../../helper/resources/Constants";

const pathCurrentUrl = window.location;
const oidcAuthority = getEnviromentVariable('OIDC_AUTHORIY');

class MenuSefaz extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sistema: this.props.Sistema,
      urlRetorno: this.props.UrlRetorno,
      openModalPreferencias: false,
    };

    this.HandleOpenModal = this.HandleOpenModal.bind(this);
  }

  componentDidMount() {
    let slideUp = (target, duration) => {
      target.style.transitionProperty = "height, margin, padding";
      target.style.transitionDuration = duration + "ms";
      target.style.boxSizing = "border-box";
      target.style.height = target.offsetHeight + "px";
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      target.style.overflow = "hidden";
      window.setTimeout(() => {
        target.style.display = "none";
        target.style.removeProperty("height");
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
      }, duration);
    };

    let slideDown = (target, duration, height) => {
      target.style.removeProperty("display");
      let display = window.getComputedStyle(target).display;
      if (display === "none") {
        display = "block";
      }
      target.style.display = display;
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      target.style.overflow = "hidden";
      target.style.boxSizing = "border-box";
      target.style.transitionProperty = "height, margin, padding";
      target.style.transitionDuration = duration + "ms";
      target.style.height = height + "px";
      target.style.removeProperty("padding-top");
      target.style.removeProperty("padding-bottom");
      target.style.removeProperty("margin-top");
      target.style.removeProperty("margin-bottom");
      window.setTimeout(() => {
        target.style.removeProperty("height");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
      }, duration);
    };

    let slideToggle = (target, duration = 500) => {
      if (window.getComputedStyle(target).display === "none") {
        return slideDown(target, duration, 355);
      } else {
        return slideUp(target, duration);
      }
    };

    document.getElementsByClassName("arrow")[0].style.display = "none";

    document.getElementById("menu").addEventListener("click", function (event) {
      let target = document.getElementsByClassName("arrow")[0];
      let display = window.getComputedStyle(target).display;
      if (display === "none") {
        document.getElementsByClassName("arrow")[0].style.display = "block";
      } else {
        document.getElementsByClassName("arrow")[0].style.display = "none";
      }
      slideToggle(document.getElementById("gridbox"), 100);
      event.stopPropagation();
    });

    document
      .getElementsByTagName("html")[0]
      .addEventListener("click", function () {
        let target = document.getElementById("gridbox");
        let display = window.getComputedStyle(target).display;
        if (display !== "none") {
          document.getElementsByClassName("arrow")[0].style.display = "none";
          slideUp(document.getElementById("gridbox"), 100);
        }
      });
  }

  Sair() {
    signOut();
  }

  Logout = (e) => {
    e.preventDefault();
    localStorage.clear();
    sessionStorage.clear();
    window.location.assign(
      `${oidcAuthority}/Perfil/Change?returnUrl=${pathCurrentUrl}`
    );
  };

  HandleOpenModal(shouldOpenModal) {
    this.setState({ openModalPreferencias: shouldOpenModal });
  }

  render() {
    const { sistema } = this.state;

    const { represented, representative } = this.props;

    const cpf = representative && formatCpfCnpj(representative?.documentNumber);
    const inscricaoRep =
      represented && formatCpfCnpj(represented?.documentNumber);

    const urlBase = this.props.ApiSefaz;

    let urlTrocarPerfil = ""; // ajustar troca do perfil

    return (
      <div className="componente">
        <div className="navbar-header menuTopo">
          <div className="SefazmenuInteracao">
            <div id="menu">
              <button className="imgMenu"></button>
            </div>
            <div id="Sefaz_contSis">
              <div className="arrow"></div>
              {representative && (
                <MenuSefazSistemas
                  Sistema={sistema}
                  Cpf={representative?.documentNumber}
                  Servidor={urlBase}
                />
              )}
            </div>
            <div className="dropdown">
              <button className="dropbtn"></button>
              <div className="dropdown-content">
                <span className="lblPreechido sefaz-login-user">
                  {representative?.name}
                </span>
                <br />
                <span className="sefaz-login-cpf">{cpf}</span>
                <div className="sefaz-representante">
                  <label className="sefaz-cnpjcpf-rep">{inscricaoRep}</label>
                  <br />
                  <span className="sefaz-nome-rep sefaz-login-user">
                    {represented?.name}
                  </span>
                </div>
                <div className="sefaz-barra-login-sair">
                  {this.props.profile === Constants.PERFIL_CONTRIBUINTE && (
                    <span className="sefaz-login-trocaperfil">
                      <button
                        id="sefaz-btn-preferencias"
                        className="sefaz-btn-preferencias"
                        onClick={() => {
                          this.HandleOpenModal(true);
                        }}
                      >
                        Preferências
                      </button>
                      <ModalPreferences
                        openModal={this.state.openModalPreferencias}
                        setOpenModal={this.HandleOpenModal}
                      />
                    </span>
                  )}
                  <span className="sefaz-login-trocaperfil">
                    <a
                      id="TrocarPerfil"
                      className="TrocarPerfil"
                      onClick={(e) => {
                        this.Logout(e);
                      }}
                      href={urlTrocarPerfil}
                    >
                      Trocar Perfil
                    </a>
                  </span>
                  <a
                    className="userLogin"
                    onClick={() => {
                      this.Sair();
                    }}
                    href="/#"
                  >
                    Sair
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class MenuSefazSistemas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sistema: this.props.Sistema,
      cpf: this.props.Cpf,
      lista: [],
    };
  }

  componentDidMount() {
    const { Cpf } = this.props;

    (async () => {
      const response = await axios.get(
        this.props.Servidor + "/Sistemas/" + Cpf
      );
      this.setState({ lista: response.data });
    })();
  }

  renderRow(row, i) {
    let src = "data:image/png;base64,";
    if (row.Sigla === "PF") src += row.ImagemHabilitado;
    else src += row.ImagemDesabilitado;

    return (
      <li key={i}>
        <a href={row.Uri} rel="noopener noreferrer" target="_blank">
          <img src={src} alt={row.Etiqueta} height="56px" width="88px" />
          <label className="labelIcon">
            <span>{row.Etiqueta !== null ? row.Etiqueta : row.Sigla}</span>
          </label>
        </a>
      </li>
    );
  }
  render() {
    const { lista } = this.state;
    let rows = [];
    for (let i = 0; i < lista.length; i++) {
      rows.push(lista[i]);
    }
    return (
      <div id="gridbox">
        <div id="innergrid">
          <ul id="icons">{rows.map(this.renderRow)}</ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    represented: store.auth.represented,
    representative: store.auth.representative,
    profile: store.auth.profile,
  };
};

export default connect(mapStateToProps, null)(MenuSefaz);
